export default [ 'en', 'th', 'pl', 'fr', 'km', 'de', 'nl', 'sk', 'lv' ]

// export default [ 'en', 'pt', 'th', 'de', 'es', 'fr' ]
